<div class="section-padding-vertical-md lg:section-padding-vertical-lg w-full flex flex-col gap">
    <div class="col-span-2 flex flex-col items-center gap-6">
        <h2>Das sagen unsere Kunden</h2>
        <p class="max-w-screen-sm text-center">
            Unsere Kunden wissen, wie wichtig es ist, digital zu überzeugen. Aber schau dir die
            Ergebnisse doch einfach selbst an.
        </p>
    </div>

    <div class="grid grid-cols-1 gap-6 lg:grid-cols-3 lg:gap-8 xl:gap-12">
        @if (items()) {
            @for (item of items(); track item) {
                <div class="card muted">
                    <div class="flex flex-col gap-4 h-full">
                        <div class="flex items-center">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="w-4 h-4 mx-0.5"
                                viewBox="0 0 16 16">
                                <path
                                    class="fill-yellow-500"
                                    d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                            </svg>

                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="w-4 h-4 mx-0.5"
                                viewBox="0 0 16 16">
                                <path
                                    class="fill-yellow-500"
                                    d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                            </svg>

                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="w-4 h-4 mx-0.5"
                                viewBox="0 0 16 16">
                                <path
                                    class="fill-yellow-500"
                                    d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                            </svg>

                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="w-4 h-4 mx-0.5"
                                viewBox="0 0 16 16">
                                <path
                                    class="fill-yellow-500"
                                    d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                            </svg>

                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                class="w-4 h-4 mx-0.5"
                                viewBox="0 0 16 16">
                                <path
                                    class="fill-yellow-500"
                                    d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z" />
                            </svg>
                        </div>

                        <p class="font-normal text-dark text-lg line-clamp-8">
                            "{{ item.fields.text }}"
                        </p>

                        <div class="flex flex-col mt-auto">
                            <p class="font-normal text-dark">{{ item.fields.name }}</p>
                            <p class="text-sm">{{ item.fields.position }}</p>
                        </div>
                    </div>
                </div>
            }
        } @else {
            <div class="w-full card muted !p-0 relative overflow-hidden animate-pulse">
                <div class="w-full h-full bg-gray-200 aspect-video"></div>
            </div>

            <div class="w-full card muted !p-0 relative overflow-hidden animate-pulse">
                <div class="w-full h-full bg-gray-200 aspect-video"></div>
            </div>

            <div class="w-full card muted !p-0 relative overflow-hidden animate-pulse">
                <div class="w-full h-full bg-gray-200 aspect-video"></div>
            </div>

            <div class="w-full card muted !p-0 relative overflow-hidden animate-pulse">
                <div class="w-full h-full bg-gray-200 aspect-video"></div>
            </div>

            <div class="w-full card muted !p-0 relative overflow-hidden animate-pulse">
                <div class="w-full h-full bg-gray-200 aspect-video"></div>
            </div>

            <div class="w-full card muted !p-0 relative overflow-hidden animate-pulse">
                <div class="w-full h-full bg-gray-200 aspect-video"></div>
            </div>
        }
    </div>
</div>
